import headerImg from "../Assets/1.jpg";
import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Menu, X } from "lucide-react";

const Navbar = () => {
  const [openDropdown, setOpenDropdown] = useState(null);
  const [mobileOpen, setMobileOpen] = useState(false);

  /* ================= DROPDOWNS ================= */

  const researchDropdown = [
    { name: "Bone", link: "/bone" },
    { name: "Tissue", link: "/tissue" },
    { name: "Biomimetics", link: "/biomimetics" },
    {
      name: "Vibration & Acoustics",
      link: "https://www.iitrpr.ac.in/downloads/sites/default/files/Vibration%20&%20Acoustics/equipments.html",
    },
  ];

  const labDropdown = [
    {
      name: "Bio-Nano Mechanical Characterisation",
      link: "https://bio-nanomaterials.webnode.page/",
    },
    {
      name: "Vibration and Acoustics Lab",
      link: "https://www.iitrpr.ac.in/downloads/sites/default/files/Vibration%20&%20Acoustics/vibration.html",
    },
    {
      name: "Control System Lab",
      link: "https://www.iitrpr.ac.in/downloads/sites/default/files/control_system_lab/control.html",
    },
    {
      name: "Mechanical Design Lab",
      link: "https://www.iitrpr.ac.in/downloads/sites/default/files/machine_design_lab/machine.html",
    },
  ];

  const groupDropdown = [
    { name: "Faculty", link: "/faculty" },
    { name: "Post-doctoral Fellow", link: "/post-doctoral-fellow" },
    { name: "P.hD Students", link: "/phd-students" },
    { name: "Undergraduate Students", link: "/ug-students" },
  ];

  const navItems = [
    { name: "Home", link: "/home" },
    { name: "Biography", link: "/biography" },
    { name: "Research Area", dropdown: "research" },
    { name: "Projects", link: "/projects" },
    { name: "Publications", link: "/publications" },
    { name: "Laboratories", dropdown: "labs" },
    { name: "Research Group", dropdown: "group" },
    { name: "Gallery", link: "/gallery" },
    { name: "News", link: "/news" },
    { name: "Contact", link: "/contact" },
    { name: "Internship(New)", link: "/internship" },
  ];

  /* ================= HELPERS ================= */

  const renderInternalLink = (to, label) => (
    <Link
      to={to}
      className="p-4 hover:bg-cyanDark transition block font-serif"
      onClick={() => setMobileOpen(false)}
    >
      {label}
    </Link>
  );

  const renderDropdownItem = (item, idx) =>
    item.link.startsWith("http") ? (
      <a
        key={idx}
        href={item.link}
        target="_blank"
        rel="noopener noreferrer"
        className="block px-4 py-2 hover:text-white font-serif"
      >
        {item.name}
      </a>
    ) : (
      <Link
        key={idx}
        to={item.link}
        className="block px-4 py-2 hover:text-white font-serif"
        onClick={() => setMobileOpen(false)}
      >
        {item.name}
      </Link>
    );

  /* ================= JSX ================= */

  return (
    <header>
      {/* ================= TOP HEADER ================= */}
      <div className="bg-header text-white p-4 flex flex-col items-center md:flex-row md:justify-between">
        <div className="flex items-center space-x-4">
          <img src={headerImg} alt="Lab Logo" className="w-28 h-28" />
          <div>
            <h1 className="text-4xl font-bold italic font-serif">
              Hard and Soft Tissue Mechanics Lab
            </h1>
            <p className="text-2xl italic mt-2">(हँसो तुम लैब) HaSo TuM Lab</p>
          </div>
        </div>

        {/* Mobile Hamburger */}
        <button
          className="md:hidden text-white ml-auto focus:outline-none"
          onClick={() => setMobileOpen(!mobileOpen)}
        >
          {mobileOpen ? <X size={32} /> : <Menu size={32} />}
        </button>
      </div>

      {/* ================= NAVBAR ================= */}
      <nav
        className={`bg-cyan text-gray-200 text-md px-2 relative transition-all duration-300
        ${mobileOpen ? "block" : "hidden"} md:flex md:flex-wrap md:justify-start`}
      >
        {navItems.map((item, idx) => (
          <div
            key={idx}
            className="relative group"
            onMouseEnter={() => item.dropdown && setOpenDropdown(item.dropdown)}
            onMouseLeave={() => item.dropdown && setOpenDropdown(null)}
          >
            {/* MAIN ITEM */}
            {item.link
              ? renderInternalLink(item.link, item.name)
              : (
                <span className="p-4 block font-serif cursor-pointer">
                  {item.name}
                </span>
              )}

            {/* RESEARCH DROPDOWN */}
            {item.dropdown === "research" && openDropdown === "research" && (
              <div className="absolute left-0 top-full bg-cyanDark text-gray-300 shadow-lg w-56 z-50">
                {researchDropdown.map(renderDropdownItem)}
              </div>
            )}

            {/* LABS DROPDOWN */}
            {item.dropdown === "labs" && openDropdown === "labs" && (
              <div className="absolute left-0 top-full bg-cyanDark text-gray-300 shadow-lg w-56 z-50">
                {labDropdown.map(renderDropdownItem)}
              </div>
            )}

            {/* GROUP DROPDOWN */}
            {item.dropdown === "group" && openDropdown === "group" && (
              <div className="absolute left-0 top-full bg-cyanDark text-gray-300 shadow-lg w-56 z-50">
                {groupDropdown.map(renderDropdownItem)}
              </div>
            )}
          </div>
        ))}
      </nav>
    </header>
  );
};

export default Navbar;
